export default "__VITE_ASSET__CTz4$rd1__"